module.exports = __webpack_public_path__ + "img/no-bg.7ff1e770.png";